import React from "react";

const NotificationIcon = ({ iconClass, color, strokeWidth }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M10.017 2.4248C7.25865 2.4248 5.01698 4.66647 5.01698 7.4248V9.83314C5.01698 10.3415 4.80032 11.1165 4.54198 11.5498L3.58365 13.1415C2.99198 14.1248 3.40032 15.2165 4.48365 15.5831C8.07532 16.7831 11.9503 16.7831 15.542 15.5831C16.5503 15.2498 16.992 14.0581 16.442 13.1415L15.4837 11.5498C15.2337 11.1165 15.017 10.3415 15.017 9.83314V7.4248C15.017 4.6748 12.767 2.4248 10.017 2.4248Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit={10}
        strokeLinecap="round"
      />
      <path
        d="M11.5584 2.6667C11.3001 2.5917 11.0334 2.53337 10.7584 2.50003C9.95843 2.40003 9.19176 2.45837 8.4751 2.6667C8.71676 2.05003 9.31676 1.6167 10.0168 1.6167C10.7168 1.6167 11.3168 2.05003 11.5584 2.6667Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5161 15.8833C12.5161 17.2583 11.3911 18.3833 10.0161 18.3833C9.33278 18.3833 8.69945 18.1 8.24945 17.65C7.79945 17.2 7.51611 16.5666 7.51611 15.8833"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeMiterlimit={10}
      />
    </svg>
  );
};

export default NotificationIcon;
